import React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

const TitanPromoCallout = ({
  payout,
  payoutIsMarkdown,
  joinUs,
  joinUsSuffix,
  highlightColor,
  bonusTextColor,
}) => {
  if (!payout && !joinUs) return null;

  return (
    <CalloutDiv
      $highlightColor={highlightColor}
      $bonusTextColor={bonusTextColor}
      className="my-5"
    >
      {payout && (
        <div className="mega-prizes">
          {payoutIsMarkdown ? (
            <ReactMarkdown>{payout}</ReactMarkdown>
          ) : (
            <p>{payout}</p>
          )}
        </div>
      )}
      {joinUs && (
        <p className="bonus">
          {joinUs} {joinUsSuffix}
        </p>
      )}
    </CalloutDiv>
  );
};

const CalloutDiv = styled.div`
  background-color: ${(props) => props.$highlightColor};
  padding: 15px;
  width: 100%;
  color: #fff;
  font-weight: 700;
  text-align: center;

  .bonus {
    margin-top: 0;
    padding-bottom: 0;
    line-height: 45px;
    font-size: 2em;
    color: ${(props) => props.$bonusTextColor};
  }

  .mega-prizes p {
    font-family: "Poppins";
    background-color: #000;
    padding: 5px;
    font-size: 20px;
    font-weight: 700;
    display: block;
    margin: 0;
  }
`;

export default TitanPromoCallout;
